<template>
  <div
    v-if="visible"
    :id="`${config.id || ''}`"
    :class="`magic-ui-container magic-layout-${config.layout || 'absolute'}${config.className ? ` ${config.className}` : ''}`"
  >
    <slot></slot>
    <magic-ui-component v-for="item in config.items" :key="item.id" :config="item"></magic-ui-component>
  </div>
</template>

<script lang="ts" setup>
import { computed, reactive } from 'vue';
import type { MContainer } from '@tmagic/schema';
import useApp from '@/hooks/useApp';
import useDisplay from '@/hooks/useDisplay';
import initValue from '../initValue';
import magicUiComponent from '../../../Component.vue';

const props = defineProps<{
  config: MContainer & typeof initValue;
}>();
useApp(props);
const { visible, show, hide } = useDisplay(props);
// 暴露给编辑器的接口请注册在这里
const exportInterface = reactive({
  show,
  hide
});

defineExpose(exportInterface);
</script>
